import React from "react";

import { graphql } from "gatsby";

import KontentItemImageCard from "./kontentItemImageCard";
import CardSlider from "../components/cardSlider/cardSlider";

interface KontentItemImageCardSliderSectionProps {
  data: Queries.kontent_item_image_card_slider_section;
}

const KontentItemImageCardSliderSection:React.FC<KontentItemImageCardSliderSectionProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  return (
    <CardSlider
      header={elements.title?.value || ""}
      description={elements.description?.value || ""}
      className="text-section__fullwidth"
      moreUrl={
        (elements.button_url?.value?.length ?? 0) > 0
          ? elements.button_url?.value?.[0]?.id
          : undefined
      }
    >
      {elements.image_cards?.value?.map((card) => (
        card && <KontentItemImageCard data={card} key={card.id} disableDescription />
      ))}
    </CardSlider>
  );
};

export const query = graphql`
  fragment KontentItemImageCardSliderSection on kontent_item_image_card_slider_section {
    id
    system {
      codename
    }
    elements {
      title {
        value
      }
      description {
        value
      }
      image_cards {
        value {
          ...KontentItemImageCard
        }
      }
      button_url {
        value {
          id
        }
      }
    }
  } 
`;

export default KontentItemImageCardSliderSection;
